<template>
    <div class="ResidentialMeals">
        <div class="row">
            <h3>
                <font-awesome-icon :icon="['fa', 'arrow-left']" @click="ChangeStartDate(-1)" class="pointer" /> <font-awesome-icon :icon="['fa', 'sync-alt']" @click="GetResidentialMeals()" class="olive-green-text pointer" />  <font-awesome-icon :icon="['fa', 'arrow-right']" @click="ChangeStartDate(1)" class="pointer" />
                <br />
                <!--<b-button @click="">{{formatDate(StartDate)}}</b-button>-->
                <flat-pickr class="form-control" v-model="StartDate" :config="DateConfig" @input="GetResidentialMeals"></flat-pickr>
                <b-button v-if="CheckPermission('ResidentialMeals_Modify')" variant="success" @click="OpenCreateMealModal()" style="margin-right:0.5rem;">ADD NEW MEAL</b-button>
            </h3>
        </div>
        <div class="row" style="overflow-x:auto;">
            <vuetable :fields="ResidentialMealOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data="ResidentialMeals"
                      ref="datatable"
                      id="residencedatatableid">

                <template slot="AteCount" scope="props">
                    <div class="AteCount">
                        <span>{{ props.rowData.ClientsAteCount }}/{{props.rowData.StaffAteCount}}</span>
                    </div>
                </template>
                <template slot="Actions" scope="props">
                    <div class="Actions">
                        <b-row no-gutters>
                            <b-col md="auto">
                                <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="OpenResidentialMealEdit(props.rowData)" />
                            </b-col>
                        </b-row>

                    </div>
                </template>
            </vuetable>
        </div>
        <div v-if="CheckPermission('ResidentialMeals_Modify')" style="position:fixed;bottom:40px;right:40px;z-index:999;">
            <div class="row">
                <b-button block class="btn btn-success" type="button" @click="$refs['import-meals-modal'].show()" style="margin-bottom:0.1rem;">
                    <font-awesome-icon :icon="['fa', 'plus']" /> IMPORT EXCEL MEAL PLAN
                </b-button>
            </div>
        </div>
        <span class="ResidentialMealEditModal">
            <b-modal ref="import-meals-modal" title="Import Excel Meals" hide-footer>
                <b-container fluid>
                    <b-form @submit="ImportResidentialMeals">
                        <b-form-checkbox v-for="residence in ResidenceList"
                                         v-model="ResidenceIDs"
                                         :key="residence.Name"
                                         :value="residence.Id"
                                         size="lg">
                            {{residence.Name}}
                        </b-form-checkbox>
                        <b-form ref="uploadFile" style="margin-top:1rem;">
                            <b-form-group>
                                <b-form-file no-drop
                                             name="FileData"
                                             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                             class="form-control" 
                                             required />
                            </b-form-group>
                        </b-form>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="HideImportMealModal()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>

        <b-modal ref="residential-meal-edit-modal" size="lg" title="Record Meal Count" hide-footer>
            <b-container fluid>
                <b-form @submit="UpdateResidentialMeal">
                    <b-row>
                        <p><b>ORIGINAL MEAL PLANNED:</b></p>
                        <div class="col-md-12">
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <!--<th width="19%">Meal Component</th>-->
                                        <th width="24%">Specific Food</th>
                                        <th width="24%">Min Portion Size</th>
                                        <th width="24%">Minimum Total Expected</th>
                                        <th width="28%" style="border-color:white;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="menuItem in ResidentialMeal.OriginalMenuItems">
                                        <!--<td>{{ menuItem.RequiredMealComponents }}</td>-->
                                        <td>{{ menuItem.SpecificFood }}</td>
                                        <td>{{ menuItem.MinSizeOfPortion }} {{ menuItem.Units }}</td>
                                        <td>{{ CalculateMinTotalExpectedForOriginalMeal(menuItem) }} {{ menuItem.Units }}</td>
                                        <td style="border-color:white;"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-row>
                    <b-row style="margin-top:15px;">
                        <p><b>ACTUAL MEAL SERVED:</b></p>
                    </b-row>
                    <b-row>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Clients Served:</label>
                                <b-form-input type="number" v-model="ResidentialMeal.ClientsAteCount" required></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Staff Served:</label>
                                <b-form-input type="number" v-model="ResidentialMeal.StaffAteCount" required></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <!--<th width="19%">Meal Component </th>-->
                                        <th width="24%">Meal Item <font-awesome-icon class="olive-green-text pointer" @click="AddActualMealRow(index)" :icon="['fa', 'plus']" /></th>
                                        <th width="24%">Min Portion Size</th>
                                        <th width="24%">Minimum Total Expected</th>
                                        <th width="24%">Total Amount Offered</th>
                                        <th width="4%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(menuItem, index) in ResidentialMeal.ActualMenuItems">
                                        <!--<td><input type="text" class="form-control" v-model="menuItem.RequiredMealComponents" required /></td>-->
                                        <td><input type="text" class="form-control" v-model="menuItem.SpecificFood" required /></td>
                                        <td><input type="number" class="form-control" v-model="menuItem.MinSizeOfPortion" style="display: inline-block; width:40%;" required /> <input type="text" class="form-control" v-model="menuItem.Units" style="display: inline-block; width:50%;" placeholder="units, i.e. oz" required /></td>
                                        <td>{{ CalculateMinTotalExpected(ResidentialMeal, menuItem) }} {{ menuItem.Units }}</td>
                                        <td><input type="number" v-model="menuItem.TotalAmountPrepared" class="form-control" style="display: inline-block; width:50%;" required /> {{ menuItem.Units }} <font-awesome-icon class="olive-green-text" :icon="['fa', 'check']" v-if="CalculateSufficientPortion(menuItem.TotalAmountPrepared, CalculateMinTotalExpected(ResidentialMeal, menuItem))" /></td>
                                        <td style="text-align: center"><font-awesome-icon class="red pointer" @click="RemoveActualMealRow(index)" :icon="['fa', 'trash']" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-row>
                    <b-row style="margin-top:15px;">
                        <p><b>Additional Info:</b></p>
                    </b-row>
                    <b-row style="margin-top:25px;">
                        <p>SCHOOL:  Record below the number of clients who were at school during this meal's service time.  If the clients also ate this meal in the home, do not double count the client here.</p>
                    </b-row>
                    <b-row>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Clients at School:</label>
                                <b-form-input type="number" v-model="ResidentialMeal.ClientsAteSchoolCount" required></b-form-input>
                            </div>
                        </div>
                    </b-row>
                    <b-row style="margin-top:25px;">
                        <p>EATING OUT:  Use the counts below to record the number of clients and staff who ate at a restaurant for this meal.  If the meal was prepared in the home, and eaten off site, do not use this section below to record the counts, as this would be counted as a regular meal.  If prepared food was purchased from a restaunt but eaten in the home, it should be counted below and not as a regular meal.  If a client also ate the meal prepared in the home, do not double count the client here.</p>
                    </b-row>
                    <b-row>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Clients Ate Out:</label>
                                <b-form-input type="number" v-model="ResidentialMeal.ClientsAteRestaurantCount"></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Staff Ate Out:</label>
                                <b-form-input type="number" v-model="ResidentialMeal.StaffAteRestaurantCount"></b-form-input>
                            </div>
                        </div>
                    </b-row>
                    <b-row style="margin-top:15px;">
                        <p><b>Comments:</b></p>
                    </b-row>
                    <b-row>
                        <div class="col-md-12">
                            <div class="form-group">
                                <textarea class="form-control" v-model="ResidentialMeal.ClientsAteComments"></textarea>
                            </div>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideActionModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                            <b-button size="md" v-if="CheckPermission('ResidentialMeals_Modify')" variant="danger" @click="DeleteResidentialMeal()">
                                DELETE MEAL
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <span class="CreateMeal">
            <b-modal ref="create-meal-modal" title="Create Meal" size="lg" hide-footer>
                <b-container fluid>
                    <b-form @submit="CreateResidentialMeal">
                        <b-row style="margin-top:15px;">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Meal:</label>
                                    <select required class="form-control" v-model="ResidentialMeal.MealName">
                                        <option value=""></option>
                                        <option value="Breakfast">Breakfast</option>
                                        <option value="Lunch">Lunch</option>
                                        <option value="Afternoon Snack">Afternoon Snack</option>
                                        <option value="Dinner">Dinner</option>
                                        <option value="Evening Snack">Evening Snack</option>
                                    </select>
                                </div>
                            </div>
                        </b-row>
                        <b-row style="margin-top:15px;">
                            <p><b>SPECIFY MEAL PATTERN REQUIREMENTS:</b></p>
                        </b-row>
                        <b-row>
                            <div class="col-md-12">
                                <table style="width:100%;">
                                    <thead>
                                        <tr>
                                            <!--<th width="19%">Meal Component </th>-->
                                            <th width="45%">Meal Item <font-awesome-icon class="olive-green-text pointer" @click="AddOriginalMealRow(index)" :icon="['fa', 'plus']" /></th>
                                            <th width="45%">Min Portion Size / Person</th>
                                            <th width="10%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(menuItem, index) in ResidentialMeal.OriginalMenuItems">
                                            <!--<td><input type="text" class="form-control" v-model="menuItem.RequiredMealComponents" required /></td>-->
                                            <td><input type="text" class="form-control" v-model="menuItem.SpecificFood" required /></td>
                                            <td><input type="number" class="form-control" v-model="menuItem.MinSizeOfPortion" style="display: inline-block; width:40%;" required /> <input type="text" class="form-control" v-model="menuItem.Units" style="display: inline-block; width:50%;" placeholder="units, i.e. oz" required /></td>
                                            <td style="text-align: center"><font-awesome-icon class="red pointer" @click="RemoveOriginalMealRow(index)" :icon="['fa', 'trash']" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="HideAddModal()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    ADD MEAL
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowRight);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faTrash } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrash);

    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import ActionButton from '../../../Core/ItemEditors/ActionButton'
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "ResidenceData"
        ],
        data: function () {
            return {
                MenuItemSchema: {
                    RequiredMealComponents: "",//string
                    MinSizeOfPortion: 0,//number
                    SpecificFood: "",//string
                    TotalAmountPrepared: null,//number
                    Units: ""//string
                },
                ResidentialMeals: '',
                File: '',
                ResidenceIDs: [],
                ResidenceList: [],
                ResidentialMeal: {},
                ResidentialMealSchema: {
                    ActualMenuItems: [],
                    ClientsAteComments: '',
                    ClientsAteCount:'',
                    Id: '',
                    MealDate:'', 
                    MealName: '',
                    OriginalMenuItems: [], 
                    ResidenceID: '',
                    StaffAteCount: '',
                    RecordedByEmployeeID: '',
                    ClientsAteSchoolCount: '',
                    ClientsAteRestaurantCount: '',
                    StaffAteRestaurantCount: '',
                    ClientsDeclinedCount: ''
                },
                StartDate: '',
                DisplayCurrentDate: '',
                ResidentialMealOptions: {
                    Fields: [
                        {
                            name: 'MealName',
                            title: 'Meal Name'
                        },
                        {
                            name: 'OriginalMenuItems',
                            title: 'OriginalMenuItems',
                            callback: 'ParseMenuItemsToList',
                        },
                        {
                            name: '__slot:AteCount',
                            title: 'Client/Staff Ate ',
                        },
                        {
                            name: '__slot:Actions',
                            title: 'Actions ',
                        },
                    ]
                },
            };
        },
        methods: {
            AddActualMealRow(index) {
                this.ResidentialMeal.ActualMenuItems.push(JSON.parse(JSON.stringify(this.MenuItemSchema)));
            },
            AddOriginalMealRow(index) {
                this.ResidentialMeal.OriginalMenuItems.push(JSON.parse(JSON.stringify(this.MenuItemSchema)));
            },
            RemoveActualMealRow(index) {
                this.ResidentialMeal.ActualMenuItems.splice(index, 1);
            },
            RemoveOriginalMealRow(index) {
                this.ResidentialMeal.ActualMenuItems.splice(index, 1);
            },
            CalculateMinTotalExpected(residentialMeal, menuItem) {
                let clientsAte = residentialMeal.ClientsAteCount ? residentialMeal.ClientsAteCount : 0;
                let staffAte = residentialMeal.StaffAteCount ? residentialMeal.StaffAteCount : 0;
                let totalAte = parseInt(clientsAte) + parseInt(staffAte);
                let minExpected = totalAte * menuItem.MinSizeOfPortion;
                return minExpected;
            },
            CalculateSufficientPortion(totalAmount, minimumSizeExpected) {
                return minimumSizeExpected != 0 && minimumSizeExpected != null && totalAmount >= minimumSizeExpected;
            },
            CalculateMinTotalExpectedForOriginalMeal(menuItem) {
                let minExpected = 8 * menuItem.MinSizeOfPortion;
                return minExpected;
            },
            ParseMenuItemsToList(jsonItems) {
                if (jsonItems) {
                    let menuArray = JSON.parse(jsonItems);
                    let itemsArray = [];
                    menuArray.forEach(function (item) {
                        itemsArray.push(item.SpecificFood);
                    });
                    return itemsArray.join(', ');
                } else {
                    return '';
                }
            },
            ParseMenuItemsToArray(jsonItems) {
                if (jsonItems) {
                    return JSON.parse(jsonItems);
                } else {
                    return [];
                }
            },
            ChangeStartDate(magnitude) {
                this.StartDate = moment(this.StartDate, 'YYYY-MM-DD').add(magnitude, 'days').format("YYYY-MM-DD");
                this.GetResidentialMeals();
            },
            OpenCreateMealModal() {
                this.ResidentialMeal = JSON.parse(JSON.stringify(this.ResidentialMealSchema))
                this.ResidentialMeal.MealDate = this.StartDate;
                this.$refs['create-meal-modal'].show();
            },
            CreateResidentialMeal(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Residential/ResidentialMeals/CreateResidentialMeal",
                    {
                        MealName: this.ResidentialMeal.MealName,
                        MealDate: this.StartDate,
                        ResidenceID: this.ResidenceData.Id,
                        OriginalMenuItems: JSON.stringify(this.ResidentialMeal.OriginalMenuItems)
                    }, this.CreateResidentialMealSuccess, () => { }, true);
            },
            CreateResidentialMealSuccess(response) {
                this.$refs['create-meal-modal'].hide();
                this.GetResidentialMeals();
            },
            GetResidentialMeals() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/ResidentialMeals/GetResidentialMeals", { StartDate: this.StartDate, EndDate: this.StartDate, ResidenceID: this.ResidenceData.Id }, this.GetResidentialMealsSuccess, () => { }, true);
            },
            GetResidentialMealsSuccess(response) {
                this.ResidentialMeals = response.data.data;
            },
            UpdateResidentialMeal(e) {
                e.preventDefault();
                let mealExport = JSON.parse(JSON.stringify(this.ResidentialMeal));
                mealExport.OriginalMenuItems = JSON.stringify(this.ResidentialMeal.OriginalMenuItems);
                mealExport.ActualMenuItems = JSON.stringify(this.ResidentialMeal.ActualMenuItems);
                this.$MasterAPI.ExecuteRequest("POST", "Residential/ResidentialMeals/UpdateResidentialMeal", { ResidentialMeal: mealExport }, this.UpdateResidentialMealSuccess, () => { }, true);
            },
            UpdateResidentialMealSuccess(response) {
                this.GetResidentialMeals();
                this.$refs['residential-meal-edit-modal'].hide();
            },
            DeleteResidentialMeal() {
                this.$MasterAPI.ExecuteRequest("POST", "Residential/ResidentialMeals/DeleteResidentialMeal", { Id: this.ResidentialMeal.Id }, this.DeleteResidentialMealSuccess, () => { }, true);
            },
            DeleteResidentialMealSuccess(response) {
                this.GetResidentialMeals();
                this.$refs['residential-meal-edit-modal'].hide();
            },
            ImportResidentialMeals(e) {
                e.preventDefault();
                let form = this.$refs['uploadFile'];
                let formData = new FormData(form);
                //pass in array to form data correctly. 
                for (var i = 0; i < this.ResidenceIDs.length; i++) {
                    formData.append('ResidenceIDs[]', this.ResidenceIDs[i]);
                }
                this.$MasterAPI.ExecuteRequest("POST", "Residential/ResidentialMeals/ImportResidentialMeals", formData, this.ImportResidentialMealsSuccess, () => { }, false);
            },
            ImportResidentialMealsSuccess(response) {
                this.HideImportMealModal();
                this.GetResidentialMeals();
            },
            HideImportMealModal() {
                this.ResidenceIDs = [];
                this.$refs['import-meals-modal'].hide();
            },
            GetResidences() {
                let subProgramIDs = [];
                for (var i = 0; i < this.SubProgramOptions.length; i++) {
                    subProgramIDs[i] = this.SubProgramOptions[i].value;
                }
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Residences/GetResidencesBySubPrograms", { SubProgramIDs: subProgramIDs }, this.GetResidencesSuccess, () => { }, false);
            },
            GetResidencesSuccess(response) {
                this.ResidenceList = response.data.data;
            },
            OpenResidentialMealEdit(rowData) {
                this.ResidentialMeal = JSON.parse(JSON.stringify(rowData));
                this.ResidentialMeal.ActualMenuItems = this.ParseMenuItemsToArray(rowData.ActualMenuItems);
                this.ResidentialMeal.OriginalMenuItems = this.ParseMenuItemsToArray(rowData.OriginalMenuItems);
                this.$refs['residential-meal-edit-modal'].show()
            },
            
            HideActionModal() {
                this.$refs["residential-meal-edit-modal"].hide();
            },
            HideAddModal() {
                this.$refs["create-meal-modal"].hide();
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DDThh:mm:ss').format(fmt)
            },
            DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
             CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Vuetable,
            flatPickr,
            ActionButton
        },
        mounted() {
            this.StartDate = moment().format("YYYY-MM-DD");
            this.GetResidences();
            //Get Residential Meals
            this.GetResidentialMeals();
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },

        }
    }
</script>

<style scoped>

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }
</style>